import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";


export class FRBinaryExpression extends FRBase{
    public Left:FRBase;
    public Right:FRBase;
    public Subtype:string;
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Left=FRFactory.GetFRElement(Options.L,this);
        this.Right=FRFactory.GetFRElement(Options.R,this);
        this.Subtype=Options.St;
    }

    Parse(): any {

        return this.MaybeExecutePromise(this.Left.Parse(),left=>{
            return this.MaybeExecutePromise(this.Right.Parse(),right=>{
                switch (this.Subtype)
                {
                    case 'Or':
                        return left==true||right==true;
                    case 'And':
                        return left==true&&right==true;
                    case 'Add':
                        if(left?.IsField)
                        {
                            if(typeof right=='string')
                                left=left.GetText();
                            else
                                left=left.GetNumber();
                        }else
                        {
                            if(left.toString().trim()==''||isNaN(Number(left)))
                                left=left.toString();
                            else
                                left=Number(left);
                        }


                        if(right?.IsField)
                        {
                            if(typeof left=='string')
                                right=right.GetText();
                            else
                                right=right.GetNumber();
                        }else
                        {
                            if(right.toString().trim()==''||isNaN(Number(right)))
                                right=right.toString();
                            else
                                right=Number(right);
                        }
                        return left+right;
                    case 'Sub':
                        return this.ToNumber(left)-this.ToNumber(right);
                    case 'Mult':
                        return this.ToNumber(left)*this.ToNumber(right);
                    case 'Div':
                        right=this.ToNumber(right);
                        if(right==0)
                            return 0;
                        return this.ToNumber(left)/right;
                    case 'Eq':
                        return this.ToScalar(left)==this.ToScalar(right);
                    case 'NEq':
                        return this.ToScalar(left)!=this.ToScalar(right);
                    case 'Gt':
                        return this.ToScalar(left)>this.ToScalar(right);
                    case 'Gte':
                        return this.ToScalar(left)>=this.ToScalar(right);
                    case 'Lt':
                        return this.ToScalar(left)<this.ToScalar(right);
                    case 'Lte':
                        return this.ToScalar(left)<=this.ToScalar(right);

                }
            })
        })




    }

    private ToScalar(parse:any)
    {
        if(Array.isArray(parse))
        {
            return (parse as any[]).reduce((previousValue, currentValue) => previousValue+this.ToScalar(currentValue),0);
        }

        if(parse?.IsField)
            return parse.GetText();
        return parse;
    }

    private ToNumber(parse: any) {
        if(Array.isArray(parse))
        {
            return (parse as any[]).reduce((previousValue, currentValue) => previousValue+this.ToNumber(currentValue),0);
        }

        if(parse?.IsField)
            return parse.GetNumber();

        parse=Number(parse);
        if(isNaN(parse))
            return 0;

        return parse;
    }
}



FRFactory.AddField('BE',FRBinaryExpression);